import { WordReveal } from "@/components/WordReveal";
import { mailtoBooking } from "@/content/speaking";

const LINKS = [
  { label: "ORCID", href: "https://orcid.org/0000-0002-7742-4907" },
  { label: "Google Scholar", href: "https://scholar.google.no/citations?user=oPth46oAAAAJ" },
  {
    label: "Semantic Scholar",
    href: "https://www.semanticscholar.org/author/Per-Arne-Andersen/33999307",
  },
  { label: "UiA-profil", href: "https://www.uia.no/english/about-uia/employees/perara12/" },
] as const;

export function Footer() {
  return (
    <footer id="contact" className="border-t border-line px-6 py-16 md:px-10 lg:px-16">
      <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-[1.1fr_0.9fr]">
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-muted">Kontakt</p>
          <WordReveal
            as="h2"
            className="mt-4 block max-w-2xl font-display text-5xl font-normal leading-[1.02] md:text-6xl"
          >
            La oss snakke om kunstig intelligens som virker i praksis
          </WordReveal>
          <p className="mt-6 max-w-prose text-lg leading-relaxed text-muted">
            Ta kontakt for foredrag, undervisning, forskningssamarbeid, veiledning eller samtaler om
            ansvarlig bruk av algoritmer i organisasjoner og samfunn.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href={mailtoBooking()}
              className="inline-flex items-center gap-3 border border-accent bg-accent px-5 py-3 font-mono text-xs uppercase tracking-widest text-bg transition-colors hover:bg-transparent hover:text-accent focus-visible:bg-transparent focus-visible:text-accent focus-visible:outline-none"
            >
              <span>Bestill foredrag</span>
              <span aria-hidden>→</span>
            </a>
            <a
              href="mailto:per.andersen@uia.no"
              className="font-mono text-xs uppercase tracking-widest text-muted underline-offset-4 hover:text-fg hover:underline focus-visible:text-fg focus-visible:underline focus-visible:outline-none"
            >
              per.andersen@uia.no
            </a>
          </div>
        </div>

        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-1">
          <section aria-labelledby="footer-links">
            <h3
              id="footer-links"
              className="font-mono text-xs uppercase tracking-widest text-muted"
            >
              Lenker
            </h3>
            <ul className="mt-4 space-y-3">
              {LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-mono text-xs uppercase tracking-widest text-fg underline-offset-4 hover:text-accent hover:underline focus-visible:text-accent focus-visible:underline focus-visible:outline-none"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </section>

          <section aria-labelledby="footer-base">
            <h3 id="footer-base" className="font-mono text-xs uppercase tracking-widest text-muted">
              Base
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-muted">
              Arendal, Norge
              <br />
              Universitetet i Agder, Kristiansand
              <br />
              Institutt for informasjonssystemer
            </p>
          </section>
        </div>
      </div>

      <div className="mx-auto mt-14 flex max-w-7xl flex-col gap-3 border-t border-line pt-6 font-mono text-[0.65rem] uppercase tracking-widest text-muted md:flex-row md:items-center md:justify-between">
        <p>© Dr. Per-Arne Andersen</p>
        <p>Bygget med Rust + React · OpenAlex · ORCID · Semantic Scholar</p>
      </div>
    </footer>
  );
}
